(function () {
  function getSections(root) {
    if (!root) return [];

    var sections = [];
    if (root.matches && root.matches('[data-lifestyle-grid]')) sections.push(root);
    sections = sections.concat(Array.prototype.slice.call(root.querySelectorAll('[data-lifestyle-grid]')));
    return sections;
  }

  function getItems(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-story-item]'));
  }

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function syncPauseState(section) {
    var state = section.__lifestyleStoryState;
    if (!state) return;

    var shouldPause = state.hover || state.focus || state.offscreen || state.hidden;
    section.classList.toggle('is-story-paused', shouldPause);
  }

  function clearProgress(section) {
    section.querySelectorAll('[data-story-progress]').forEach(function (progress) {
      progress.classList.remove('is-running');
    });
  }

  function restartProgress(section) {
    clearProgress(section);

    if (section.dataset.storyAutoplay !== 'true') return;

    var activeProgress = section.querySelector('.home-lifestyle-grid__item.is-active [data-story-progress]');
    if (!activeProgress) return;

    activeProgress.offsetWidth;
    activeProgress.classList.add('is-running');
  }

  function updateAutoplay(section) {
    var state = section.__lifestyleStoryState;
    if (!state) return;

    var shouldEnable = state.desktop && !state.reducedMotion && state.inViewport && !isDesignMode();
    var isEnabled = section.dataset.storyAutoplay === 'true';

    if (shouldEnable && !isEnabled) {
      section.dataset.storyAutoplay = 'true';
      restartProgress(section);
    } else if (!shouldEnable && isEnabled) {
      section.dataset.storyAutoplay = 'false';
      clearProgress(section);
    } else if (!shouldEnable) {
      section.dataset.storyAutoplay = 'false';
    }

    syncPauseState(section);
  }

  function activateStory(section, index) {
    var items = getItems(section);
    if (!items.length) return;

    var activeIndex = Math.max(0, Math.min(Number(index) || 0, items.length - 1));

    items.forEach(function (item, itemIndex) {
      var isActive = itemIndex === activeIndex;
      item.classList.toggle('is-active', isActive);

      var switchControl = item.querySelector('[data-story-switch]');
      if (switchControl) switchControl.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      var link = item.querySelector('[data-story-link]');
      if (link && link.tagName === 'A') {
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      }
    });

    restartProgress(section);
  }

  function bindMediaQuery(query, callback, cleanup) {
    if (!query) return;

    if (query.addEventListener) {
      query.addEventListener('change', callback);
      cleanup.push(function () { query.removeEventListener('change', callback); });
    } else if (query.addListener) {
      query.addListener(callback);
      cleanup.push(function () { query.removeListener(callback); });
    }
  }

  function initializeLifestyleGrid(section) {
    if (!section || section.dataset.storyInitialized === 'true') return;

    section.dataset.storyInitialized = 'true';
    section.dataset.storyReady = 'true';
    section.dataset.storyAutoplay = 'false';

    var desktopQuery = window.matchMedia('(min-width: 750px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var state = {
      desktop: desktopQuery.matches,
      reducedMotion: reducedMotionQuery.matches,
      inViewport: false,
      offscreen: true,
      hover: false,
      focus: false,
      hidden: document.hidden
    };
    var cleanup = [];
    section.__lifestyleStoryState = state;

    activateStory(section, 0);

    var revealTargets = section.querySelectorAll('[data-story-intro]');
    revealTargets.forEach(function (target) {
      if (state.reducedMotion || !('IntersectionObserver' in window)) target.classList.add('is-visible');
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target === section) {
              state.inViewport = entry.isIntersecting;
              state.offscreen = !entry.isIntersecting;
              updateAutoplay(section);
              return;
            }

            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );

      revealTargets.forEach(function (target) { observer.observe(target); });
      observer.observe(section);
      section.__lifestyleStoryObserver = observer;
      cleanup.push(function () {
        observer.disconnect();
        delete section.__lifestyleStoryObserver;
      });
    }

    syncPauseState(section);

    var updateMediaState = function () {
      state.desktop = desktopQuery.matches;
      state.reducedMotion = reducedMotionQuery.matches;
      updateAutoplay(section);
    };
    bindMediaQuery(desktopQuery, updateMediaState, cleanup);
    bindMediaQuery(reducedMotionQuery, updateMediaState, cleanup);

    var onPointerEnter = function () {
      state.hover = true;
      syncPauseState(section);
    };
    var onPointerLeave = function () {
      state.hover = false;
      syncPauseState(section);
    };
    var onFocusIn = function (event) {
      state.focus = true;

      var control = event.target.closest('[data-story-link], [data-story-switch]');
      if (control && section.contains(control)) {
        var item = control.closest('[data-story-item]');
        if (item && !item.classList.contains('is-active')) activateStory(section, item.dataset.storyIndex);
      }

      syncPauseState(section);
    };
    var onFocusOut = function (event) {
      state.focus = Boolean(event.relatedTarget && section.contains(event.relatedTarget));
      syncPauseState(section);
    };
    var onClick = function (event) {
      var switchControl = event.target.closest('[data-story-switch]');
      if (!switchControl || !section.contains(switchControl)) return;

      var item = switchControl.closest('[data-story-item]');
      if (item) activateStory(section, item.dataset.storyIndex);
    };
    var onPointerOver = function (event) {
      var control = event.target.closest('[data-story-link], [data-story-switch]');
      if (!control || !section.contains(control)) return;

      var item = control.closest('[data-story-item]');
      if (item && !item.classList.contains('is-active')) activateStory(section, item.dataset.storyIndex);
    };
    var onAnimationEnd = function (event) {
      if (!event.target.matches('[data-story-progress]') || event.animationName !== 'cm-lifestyle-story-progress') return;
      if (section.dataset.storyAutoplay !== 'true' || section.classList.contains('is-story-paused')) return;

      var item = event.target.closest('[data-story-item]');
      if (!item || !item.classList.contains('is-active')) return;

      var items = getItems(section);
      var currentIndex = Number(item.dataset.storyIndex) || 0;
      activateStory(section, (currentIndex + 1) % items.length);
    };
    var onVisibilityChange = function () {
      state.hidden = document.hidden;
      syncPauseState(section);
    };

    section.addEventListener('pointerenter', onPointerEnter);
    section.addEventListener('pointerleave', onPointerLeave);
    section.addEventListener('pointerover', onPointerOver);
    section.addEventListener('focusin', onFocusIn);
    section.addEventListener('focusout', onFocusOut);
    section.addEventListener('click', onClick);
    section.addEventListener('animationend', onAnimationEnd);
    document.addEventListener('visibilitychange', onVisibilityChange);

    cleanup.push(function () {
      section.removeEventListener('pointerenter', onPointerEnter);
      section.removeEventListener('pointerleave', onPointerLeave);
      section.removeEventListener('pointerover', onPointerOver);
      section.removeEventListener('focusin', onFocusIn);
      section.removeEventListener('focusout', onFocusOut);
      section.removeEventListener('click', onClick);
      section.removeEventListener('animationend', onAnimationEnd);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    });

    section.__lifestyleStoryCleanup = function () {
      cleanup.forEach(function (dispose) { dispose(); });
      delete section.__lifestyleStoryCleanup;
      delete section.__lifestyleStoryState;
    };
  }

  function initializeAllLifestyleGrids(root) {
    getSections(root || document).forEach(initializeLifestyleGrid);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeAllLifestyleGrids(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllLifestyleGrids(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest('[data-story-item]');
    if (!item) return;

    var section = item.closest('[data-lifestyle-grid]');
    if (section) activateStory(section, item.dataset.storyIndex);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches && event.target.matches('[data-lifestyle-grid]')
      ? event.target
      : event.target.querySelector('[data-lifestyle-grid]');

    if (!section) return;

    if (section.__lifestyleStoryCleanup) section.__lifestyleStoryCleanup();
    clearProgress(section);
    delete section.dataset.storyInitialized;
  });
})();
